"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on 15.05.2019
 */

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * Converts attributes of WindowDerivedData
 * @author JMt
 */


var WindowDerivedDataConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(WindowDerivedDataConverter, _DataObjectConverter_);

  function WindowDerivedDataConverter() {
    _classCallCheck(this, WindowDerivedDataConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(WindowDerivedDataConverter).apply(this, arguments));
  }

  return WindowDerivedDataConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.WindowDerivedDataConverter = WindowDerivedDataConverter;